import _defineProperty from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { testClonabilityOfAudioWorkletNodeOptions } from '../helpers/test-clonability-of-audio-worklet-node-options';
export var createNativeAudioWorkletNodeFactory = function createNativeAudioWorkletNodeFactory(createInvalidStateError, createNativeAudioWorkletNodeFaker, createNativeGainNode, createNotSupportedError, monitorConnections) {
  return function (nativeContext, baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, options) {
    if (nativeAudioWorkletNodeConstructor !== null) {
      try {
        var nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeContext, name, options);
        var patchedEventListeners = new Map();
        var onprocessorerror = null;
        Object.defineProperties(nativeAudioWorkletNode, {
          /*
           * Bug #61: Overwriting the property accessors for channelCount and channelCountMode is necessary as long as some
           * browsers have no native implementation to achieve a consistent behavior.
           */
          channelCount: {
            get: function get() {
              return options.channelCount;
            },
            set: function set() {
              throw createInvalidStateError();
            }
          },
          channelCountMode: {
            get: function get() {
              return 'explicit';
            },
            set: function set() {
              throw createInvalidStateError();
            }
          },
          // Bug #156: Chrome and Edge do not yet fire an ErrorEvent.
          onprocessorerror: {
            get: function get() {
              return onprocessorerror;
            },
            set: function set(value) {
              if (typeof onprocessorerror === 'function') {
                nativeAudioWorkletNode.removeEventListener('processorerror', onprocessorerror);
              }

              onprocessorerror = typeof value === 'function' ? value : null;

              if (typeof onprocessorerror === 'function') {
                nativeAudioWorkletNode.addEventListener('processorerror', onprocessorerror);
              }
            }
          }
        });

        nativeAudioWorkletNode.addEventListener = function (addEventListener) {
          return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            if (args[0] === 'processorerror') {
              var unpatchedEventListener = typeof args[1] === 'function' ? args[1] : typeof args[1] === 'object' && args[1] !== null && typeof args[1].handleEvent === 'function' ? args[1].handleEvent : null;

              if (unpatchedEventListener !== null) {
                var patchedEventListener = patchedEventListeners.get(args[1]);

                if (patchedEventListener !== undefined) {
                  args[1] = patchedEventListener;
                } else {
                  args[1] = function (event) {
                    // Bug #178: Chrome, Edge and Opera do fire an event of type error.
                    if (event.type === 'error') {
                      Object.defineProperties(event, {
                        type: {
                          value: 'processorerror'
                        }
                      });
                      unpatchedEventListener(event);
                    } else {
                      unpatchedEventListener(new ErrorEvent(args[0], _objectSpread({}, event)));
                    }
                  };

                  patchedEventListeners.set(unpatchedEventListener, args[1]);
                }
              }
            } // Bug #178: Chrome, Edge and Opera do fire an event of type error.


            addEventListener.call(nativeAudioWorkletNode, 'error', args[1], args[2]);
            return addEventListener.call.apply(addEventListener, [nativeAudioWorkletNode].concat(args));
          };
        }(nativeAudioWorkletNode.addEventListener);

        nativeAudioWorkletNode.removeEventListener = function (removeEventListener) {
          return function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            if (args[0] === 'processorerror') {
              var patchedEventListener = patchedEventListeners.get(args[1]);

              if (patchedEventListener !== undefined) {
                patchedEventListeners.delete(args[1]);
                args[1] = patchedEventListener;
              }
            } // Bug #178: Chrome, Edge and Opera do fire an event of type error.


            removeEventListener.call(nativeAudioWorkletNode, 'error', args[1], args[2]);
            return removeEventListener.call(nativeAudioWorkletNode, args[0], args[1], args[2]);
          };
        }(nativeAudioWorkletNode.removeEventListener);
        /*
         * Bug #86: Chrome and Edge do not invoke the process() function if the corresponding AudioWorkletNode is unconnected but
         * has an output.
         */


        if (options.numberOfOutputs !== 0) {
          var nativeGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: 0
          });
          nativeAudioWorkletNode.connect(nativeGainNode).connect(nativeContext.destination);

          var whenConnected = function whenConnected() {
            return nativeGainNode.disconnect();
          };

          var whenDisconnected = function whenDisconnected() {
            return nativeGainNode.connect(nativeContext.destination);
          }; // @todo Disconnect the connection when the process() function of the AudioWorkletNode returns false.


          return monitorConnections(nativeAudioWorkletNode, whenConnected, whenDisconnected);
        }

        return nativeAudioWorkletNode;
      } catch (err) {
        // Bug #60: Chrome, Edge & Opera throw an InvalidStateError instead of a NotSupportedError.
        if (err.code === 11) {
          throw createNotSupportedError();
        }

        throw err;
      }
    } // Bug #61: Only Chrome & Opera have an implementation of the AudioWorkletNode yet.


    if (processorConstructor === undefined) {
      throw createNotSupportedError();
    }

    testClonabilityOfAudioWorkletNodeOptions(options);
    return createNativeAudioWorkletNodeFaker(nativeContext, baseLatency, processorConstructor, options);
  };
};